import { Tag, Checkbox, Table, message } from 'antd'
import { get, map, groupBy } from 'lodash-es'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { switchBlukOrder } from '../../../api'
import { ACCOUNT_FIELDS, DAN_FIELDS } from '../../../constants'
import { useMemo } from 'react'

const StepDans = ({ juId, isHistory, title, accountList, data }) => {
  const queryClient = useQueryClient()
  const switchBlukOrderMutation = useMutation({
    mutationFn: switchBlukOrder,
    onSuccess: () => {
      queryClient.invalidateQueries(['ju-item', juId, 'dans'])
    },
  })

  const accountsObj = useMemo(() => groupBy(accountList, 'rowid'), [accountList])

  const columns = [
    {
      title: '账号',
      dataIndex: DAN_FIELDS.ACCOUNT,
      key: DAN_FIELDS.ACCOUNT,
      width: '15%',
      render: text => {
        const d = JSON.parse(text)
        const account = d?.[0]

        return <div>{account?.name}</div>
      },
    },
    {
      title: '序号',
      dataIndex: DAN_FIELDS.ACCOUNT_ROWID,
      key: DAN_FIELDS.ACCOUNT_ROWID,
      width: '10%',
      render: text => {
        const num = get(accountsObj, `${text}.[0].${ACCOUNT_FIELDS.SEQUENCE}`)
        return num
      },
    },
    {
      title: 'cfgsdok订单id',
      dataIndex: DAN_FIELDS.TAO_ORDER_ID,
      key: DAN_FIELDS.TAO_ORDER_ID,
      width: '15%',
      render: (text, record, index) => {
        if (!text) {
          const pos = index % 3
          const color = pos === 0 ? '#ff4d4f' : pos === 1 ? '#faad14' : '#1677ff'
          return <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 2, backgroundColor: color }} />
        }
        return text
      },
    },
    {
      title: 'cfgsdok订单状态',
      dataIndex: DAN_FIELDS.TAO_ORDER_STATUS,
      key: '6689fc9b0207cf7520fc91e8',
      width: '15%',
      render: text => {
        if (text === 'Ticket') {
          return '已出票'
        }

        if (text === 'Accept') {
          return '待出票'
        }

        return text
      },
    },
    {
      title: '禁用批量下单',
      dataIndex: DAN_FIELDS.DISABLE_BULK,
      key: DAN_FIELDS.DISABLE_BULK,
      width: '15%',
      render: (text, record) => {
        if (isHistory) {
          return text
        }
        return (
          <Checkbox
            checked={text === '1' ? true : false}
            onChange={e => {
              const targetValue = e.target.checked ? '1' : '0'

              if (targetValue !== text) {
                switchBlukOrderMutation.mutateAsync({ rowId: record.rowid, value: targetValue }).then(() => {
                  message.success('设置成功')
                })
              }
            }}
          ></Checkbox>
        )
      },
    },
    {
      title: '是否中奖',
      dataIndex: DAN_FIELDS.AWARD_STATUS,
      key: DAN_FIELDS.AWARD_STATUS,
      render: (text, record) => {
        if (text === '已中奖') {
          return <Tag color="red">{text}</Tag>
        }

        if (text === '未中奖') {
          return (
            <Tag color="default" bordered={false}>
              {text}
            </Tag>
          )
        }

        return '---'
      },
    },
    {
      title: '连红',
      dataIndex: DAN_FIELDS.LIANHONG,
      key: DAN_FIELDS.LIANHONG,
      width: '15%',
      render: (text, record) => {
        const lianhong = Number(text)
        const isWin = get(record, DAN_FIELDS.AWARD_STATUS) === '已中奖'

        if (isWin) {
          return <Tag color="#f50">{lianhong + 1}</Tag>
        }

        if (get(record, DAN_FIELDS.AWARD_STATUS) === '未中奖') {
          return <b>0</b>
        }

        return <b>{text}</b>
      },
    },
  ]

  const dataSource = map(data, item => {
    return {
      key: item.rowid,
      ...item,
    }
  })

  return (
    <div>
      <div style={{ marginTop: 20 }}>{title}</div>

      <Table
        columns={columns}
        // rowSelection={{ ...rowSelection, checkStrictly: false }}
        dataSource={dataSource}
        pagination={false}
        size="small"
        onRow={(record, rowIndex) => {
          const pos = rowIndex % 3
          const bg = pos === 0 ? '#fff1f0' : pos === 1 ? '#fffbe6' : '#e6f4ff'
          return { style: { backgroundColor: bg } }
        }}
      />
    </div>
  )
}

export default StepDans
